import { useCallback, useEffect, useState } from 'react';
import { contextFactory } from '../../hooks/context-factory';
import { useUniqueID } from '../../hooks/use-unique-id';
import { ActiveSlide, CarouselProviderProps, SlideSetter } from './types';

export const [ActiveSlideContext, useActiveSlide] = contextFactory<ActiveSlide>();
export const [SlideSetterContext, useSlideSetter] = contextFactory<SlideSetter>();

export const CarouselProvider = ({ children, initialSlide, controlledSlide, onChange }: CarouselProviderProps) => {
  const [activeSlideId, setActiveSlideId] = useState(controlledSlide ?? initialSlide);
  const uniqueId = useUniqueID();

  useEffect(() => {
    setActiveSlideId(controlledSlide ?? initialSlide);
  }, [controlledSlide, initialSlide]);

  const activeSlide = controlledSlide ?? activeSlideId;

  const handleSlideChange = useCallback(
    (id: string) => {
      setActiveSlideId(id);
      if (typeof onChange === 'function') {
        onChange(id);
      }
    },
    [onChange]
  );

  return (
    <SlideSetterContext.Provider value={handleSlideChange}>
      <ActiveSlideContext.Provider value={{ activeSlide: activeSlide || '', uniqueId }}>
        {children}
      </ActiveSlideContext.Provider>
    </SlideSetterContext.Provider>
  );
};
